

function onShopifyReady(callback) {
  const interval = setInterval(() => {
    const selected = document.querySelector('input[name="id"]:checked, select[name="id"] option:checked');
    if (selected && selected.value) {
      clearInterval(interval);
      callback();
    }
  }, 100);
}


onShopifyReady(() => {
  const variantSelectors = document.querySelectorAll('variant-radios, variant-selects');
  const variants = window.productVariants || [];

  function filterImagesByUPC(upc) {
    const mediaItems = document.querySelectorAll('.product__media-item');

    mediaItems.forEach(item => {
      const img = item.querySelector('img');
      const altText = img?.alt || img?.getAttribute('data-media-alt') || '';
      const match = altText.includes(upc);

      item.style.display = match ? '' : 'none';
    });
  }

  function getSelectedVariantId() {
    const selected = document.querySelector('input[name="id"]:checked, select[name="id"] option:checked');
    return selected?.value;
  }

  function handleVariantChange() {
    const selectedId = getSelectedVariantId();
    const variant = variants.find(v => v.id == selectedId);

    console.log('Selected variant ID:', selectedId);
    console.log('Matching variant:', variant);
    console.log('Filtering images for barcode:', variant?.barcode);

    if (variant && variant.barcode) {
      filterImagesByUPC(variant.barcode);
    }
  }

  variantSelectors.forEach(selector => {
    selector.addEventListener('change', handleVariantChange);
  });

  document.addEventListener('variant:change', handleVariantChange);

  // Initial load
  handleVariantChange();
});
